const navigateTo = uni.navigateTo
const redirectTo = uni.redirectTo
const reLaunch = uni.reLaunch
const switchTab = uni.switchTab
const navigateBack = uni.navigateBack
uni.navigateTo = navigateTo
uni.redirectTo = redirectTo
uni.reLaunch = reLaunch
uni.switchTab = switchTab
uni.navigateBack = navigateBack
;
import {
  createSSRApp
} from 'vue'
import App from './App.vue'
// 国际化
import { setupI18n } from './lang'
import { setupRouter } from './router'
import { setupStore } from './stores'
import { applyH5MapConfig } from './utils/map-config'
// 兼容低版浏览器
import legacy from './plugin/legacy'
legacy()
applyH5MapConfig()

// 设置默认语言
uni.getSystemInfo({
  success: () => {
    uni.setStorageSync('cloudLang', 'zh_CN')
  }
})
export function createApp () {
  const app = createSSRApp(App)
  app.use(setupI18n)
  setupRouter(app)
  setupStore(app)
  return {
    app
  }
}
